import React, { useState, useEffect, useMemo } from "react"
import {useTranslation} from "react-i18next";
import i18next from "i18next";

function ScrollingNavMenu(props) {
    const {t, i18n} = useTranslation('common');
//   i18n.changeLanguage("el");
React.useEffect(() => {
if( props?.lan == 'en' ) {
    i18next.changeLanguage("en");
}else{
    i18next.changeLanguage("el");
}
}, []);
    return (<section class="description_list_section">
        
        <div class="container_size">
            <div class="description_list">
                <ul class="nav_menu_single">
                    {(props?.MetaData?.rem_profile_enable?.[0] == 'Yes') ?
                        <li class="active-2 rem_nav_profile"><a href="#profile_section">{t('PROFILE')}</a></li>
                        : ''
                    }
                    {(props?.MetaData?.rem_service_enable?.[0] == 'Yes') ?
                        <li class="rem_nav_services"><a href="#services_section">{t('SERVICES')}</a></li>
                        : ''
                    }
                    <li class="rem_nav_contact"><a href="#contact_section">{t('CONTACT')}</a></li>
                    <li class="rem_nav_reviews"><a href="#review_section">{t('REVIEWS')}</a></li>
                    {(props?.MetaData?.rem_gallery_enable?.[0] == 'Yes') ?
                        <li class="rem_nav_gallery"><a href="#gallery_section">{t('GALLERY')}</a></li>
                        : ''
                    }
                    {/* <li class="rem_nav_offers"><a href="#offer_section">{t('OFFERS')}</a></li> */}
                    {(props?.MetaData?.rem_faq_enable?.[0] == 'Yes') ?
                        <li class="rem_nav_faq"><a href="#faqs_section">{t('FAQ’S')}</a></li>
                        : ''
                    }
                </ul>
            </div>
        </div>
    </section>);
}

export default ScrollingNavMenu;